import React, { useEffect, useState } from "react";
import { getData } from "../../../Utils/Common/Library";
import FeatureIDs from "../../../Utils/Common/FeatureIDs";
import Atomic from "../../../AComponent/Atomic";

const { Dropdown } = Atomic;

const RatingScaleValues = ({ ratingScaleId, value, onChange }) => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    if (ratingScaleId) {
      getData({ featureId: FeatureIDs.RatingScale }).then((res) => {
        const data = res?.Data || [];
        const item = data.find((d) => d.TransactionID === ratingScaleId);
        if (item) {
          const scaleValues = item.ScaleValues || [];
          setItems(
            scaleValues.map((s) => ({ label: s.Label, value: s.Value }))
          );
        }
      });
    }
  }, [ratingScaleId]);

  return (
    <Dropdown
      label={"Default Adjusted Rating"}
      menuItems={items}
      value={value}
      onChange={onChange}
    />
  );
};

export default RatingScaleValues;
